<template>
  <div class="grow">
    <div class="st-window">
      <div class="header">
        <span class="text">{{ $t('stranger.data.sections.calllist') }}</span>
        <div class="close-button">
          <button class="st-button" @click="close()">X</button>
        </div>
      </div>
      <div class="content st-scrollbar">
        <div>
          <img src="/stranger/assets/images/ST_LOGO_HAWKINS.png">
          <div class="cl-title">{{ $t('stranger.calllist.title') }}</div>
          
          <div v-for="(entry, index) in entries" :key="index" class="cl-entry">
            <div class="cl-date">
              {{ toDateString(entry.date, entry.time) }}
            </div>
            <div class="cl-in">
              <img src="/stranger/assets/images/ST_ICONE_APPEL_ENTRANT.png" />
              {{ $t('stranger.calllist.place_' + entry.place.toLowerCase()) }}
            </div>
            <div class="cl-out">
              <img src="/stranger/assets/images/ST_ICONE_APPEL_SORTANT.png" />
              {{ entry.number }}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
  import currentGameMixin from "@/mixins/currentGameMixin";
  import axios from "axios";

  export default {
    name: "CallList",

    components: {},

    mixins: [currentGameMixin],

    data: () => ({
      entries: [],
    }),

    methods: {
      close() {
        this.$router.push({ name: 'stranger-home' });
      },
      toDateString(date, time) {
        const d = new Date(`${date}T${time}`);
        return this.$strangerStore.formatDate(d, this.$t('stranger.calllist.date_format'))
      }
    },

    watch: {

    },

    computed: { },

    async mounted() { 
      const { data } = await axios.get('/stranger/data/calllist.json');
      this.entries = data;
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/css/stranger.scss';

  .st-window {
    .content {
      max-height: 400px;
      overflow-y: scroll;

      img {
        max-width: 220px;
      }

      .cl-title {
        color: $light-color;
        margin-top: 32px;
        margin-bottom: 12px;
        text-transform: uppercase;
      }

      .cl-entry {
        border: 2px solid $accent-color;
        padding: 10px;
        max-width: 400px;
        margin: auto;
        text-align: left;

        img {
          width: 16px;
          padding-right: 4px;
        }

        .cl-date, .cl-in {
          color: $accent-color;
        }

        .cl-out {
          color: $light-color;
        }
      }
    }
  }
</style>
  